import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      POINTS_YOU_CAN_SPEND: "Verdipoeng du kan bruke",
      POINTS_THAT_EXPIRE: "Verdipoeng som utløper",
      SHOW_ALL: "Vis alle",
      SHOW_LESS: "Vis færre",
      POINT_EXPIRY_FORMAT: "dd. MMM yyyy",
      YOU_CURRENTLY_HAVE_NO_POINTS:
        "Du har for øyeblikket ingen lojalitetspoeng",
      READ_MORE_ABOUT_POINTS_HERE: "Les mer om poeng her",
    },
    se: {
      POINTS_YOU_CAN_SPEND: "Värdepoäng du kan använda",
      POINTS_THAT_EXPIRE: "Värdepoäng som löper ut",
      SHOW_ALL: "Visa alla",
      SHOW_LESS: "Visa färre",
      POINT_EXPIRY_FORMAT: "yyyy-MM-dd",
      YOU_CURRENTLY_HAVE_NO_POINTS:
        "Du har för närvarande inga lojalitetspoäng",
      READ_MORE_ABOUT_POINTS_HERE: "Läs mer om poäng här",
    },
    dk: {
      POINTS_YOU_CAN_SPEND: "Samlet antal værdipoint",
      POINTS_THAT_EXPIRE: "Udløbsdato for optjente værdipoint",
      SHOW_ALL: "Vis alle",
      SHOW_LESS: "Vis færre",
      POINT_EXPIRY_FORMAT: "dd. MMM yyyy",
      YOU_CURRENTLY_HAVE_NO_POINTS: "Du har i øjeblikket ingen loyalitetspoint",
      READ_MORE_ABOUT_POINTS_HERE: "Læs mere om point her",
    },
  } as const
)[language];
